// src/components/NotifModalShell.tsx
import React from 'react';
import { Modal, Space } from 'antd';
import { useIsMobile } from '../hooks/useIsMobile';

type Props = {
  title: React.ReactNode;
  open: boolean;
  onClose: () => void;
  /** ширина модалки (по умолчанию 980 как у заказов) */
  width?: number;

  /** левая группа кнопок в шапке (например «Отметить прочитанными», «Отметить всё…») */
  leftControls?: React.ReactNode;
  /** правая группа (например «Удалить выбранные») */
  rightControls?: React.ReactNode;

  /** основной контент (обычно таблица) */
  children: React.ReactNode;

  /** подсказка/хинт под таблицей */
  hint?: React.ReactNode;
};

const NotifModalShell: React.FC<Props> = ({
  title,
  open,
  onClose,
  width = 980,
  leftControls,
  rightControls,
  children,
  hint,
}) => {
  const isMobile = useIsMobile();

  return (
    <Modal
      title={title}
      open={open}
      onCancel={onClose}
      footer={null}
      // Заданная в пикселях ширина не помещалась на телефоне: модалка на 980px
      // вылезала за оба края экрана, обрезая заголовок слева и кнопку удаления
      // справа. На узких экранах отдаём ей ширину окна за вычетом полей.
      width={isMobile ? 'calc(100vw - 16px)' : width}
      style={isMobile ? { top: 8, maxWidth: '100vw', margin: 0 } : undefined}
      // Длинные таблицы прокручиваются внутри тела, а не растягивают модалку.
      styles={isMobile ? { body: { maxHeight: '75vh', overflowY: 'auto' } } : undefined}
      destroyOnHidden
    >
      {(leftControls || rightControls) && (
        <div
          style={{
            display: 'flex',
            // На телефоне кнопки встают в столбец: в строку они не помещаются
            // и «Удалить выбранные» уезжала за правый край.
            flexDirection: isMobile ? 'column' : 'row',
            alignItems: isMobile ? 'stretch' : 'center',
            justifyContent: 'space-between',
            gap: 8,
            marginBottom: 12,
          }}
        >
          <Space wrap>{leftControls}</Space>
          <Space wrap>{rightControls}</Space>
        </div>
      )}

      {children}

      {hint ? <div style={{ marginTop: 8 }}>{hint}</div> : null}
    </Modal>
  );
};

export default NotifModalShell;
